import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { validateTenantId } from './paths';
import { selectOperationalTenantTimezone } from './timezoneSource';

export const getOperationalTenantTimezone = async (tenantIdInput: string): Promise<string> => {
  const tenantId = validateTenantId(tenantIdInput);
  const businessInfo = await getDoc(doc(db, 'booking-websites', tenantId, 'config', 'businessInfo'));
  const configuredTimezone = selectOperationalTenantTimezone(businessInfo.data(), undefined);
  if (configuredTimezone) return configuredTimezone;

  const tenant = await getDoc(doc(db, 'booking-websites', tenantId));
  const fallbackTimezone = selectOperationalTenantTimezone(undefined, tenant.data());
  if (fallbackTimezone) return fallbackTimezone;

  throw new Error(`Tenant "${tenantId}" does not have a valid operational timezone.`);
};
